var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3514 8.74902L20.6081 14.018C20.7344 14.1445 20.7344 14.3496 20.6081 14.4762L15.58 19.516C15.4537 19.6426 15.2491 19.6426 15.1228 19.516L10.0947 14.4762C9.96844 14.3496 9.96844 14.1445 10.0947 14.018L15.3514 8.74902ZM15.3514 8.74902L12.6088 6",
    stroke: "#373737",
    strokeWidth: 1.47759
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 18.3801C24.0001 19.2748 23.2765 20 22.3839 20C21.4914 20 20.7678 19.2748 20.7678 18.3801C20.7678 18.0154 20.8881 17.6788 21.091 17.4081C21.3859 17.0147 21.8553 16.7603 22.3839 16.7603C22.9126 16.7603 23.382 17.0147 23.6768 17.4081C23.8798 17.6788 24.0001 18.0154 24.0001 18.3801Z",
    fill: "#373737"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3839 16.7603V15.4644L21.091 17.4081C21.3859 17.0147 21.8553 16.7603 22.3839 16.7603Z",
    fill: "#373737"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3839 15.4644V16.7603C22.9126 16.7603 23.382 17.0147 23.6768 17.4081L22.3839 15.4644Z",
    fill: "#373737"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1113 19.3521L10.1013 14.3304V14.1685H20.2829L15.1113 19.3521Z",
    fill: "#373737",
    stroke: "#373737",
    strokeWidth: 0.295518,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 14.25L20.4643 12.8358L21.8785 14.25L20.4643 15.6642L20.05 14.25Z",
    fill: "#373737"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 23,
    width: 20,
    height: 3,
    fill: "#58E7AB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.0228959ce45e35557b89fd6b2b762a0a.svg";
export { ForwardRef as ReactComponent };